<script setup>
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { useAuthStore } from '../stores/auth.js'

const router = useRouter()
const authStore = useAuthStore()

const currentPassword = ref('')
const newPassword = ref('')
const confirmPassword = ref('')

const handleChangePassword = async () => {
  if (newPassword.value !== confirmPassword.value) {
    alert('Passwords do not match')
    return
  }

  const result = await authStore.changePassword(currentPassword.value, newPassword.value)

  if (result.success) {
    const userRefresh = await authStore.fetchUser()
    if (!userRefresh.success) {
      return
    }

    currentPassword.value = ''
    newPassword.value = ''
    confirmPassword.value = ''
    authStore.log('PASSWORD_CHANGE_SUCCESS_REDIRECT target=/dashboard')
    await router.push('/dashboard')
  }
}
</script>

<template>
  <div class="change-password-container">
    <h1>Change Password</h1>
    <form @submit.prevent="handleChangePassword">
      <div class="form-group">
        <label for="current-password">Current Password</label>
        <input
          id="current-password"
          v-model="currentPassword"
          type="password"
          required
          autocomplete="current-password"
        />
      </div>

      <div class="form-group">
        <label for="new-password">New Password</label>
        <input
          id="new-password"
          v-model="newPassword"
          type="password"
          required
          autocomplete="new-password"
        />
      </div>

      <div class="form-group">
        <label for="confirm-password">Confirm Password</label>
        <input
          id="confirm-password"
          v-model="confirmPassword"
          type="password"
          required
          autocomplete="new-password"
        />
      </div>

      <button type="submit" :disabled="authStore.loading">
        {{ authStore.loading ? 'Changing...' : 'Change Password' }}
      </button>

      <div v-if="authStore.error" class="error">
        {{ authStore.error }}
      </div>
    </form>
  </div>
</template>

<style scoped>
.change-password-container {
  max-width: 400px;
  margin: 100px auto;
  padding: 2rem;
  border: 1px solid #ddd;
  border-radius: 8px;
}

h1 {
  text-align: center;
  color: #111827;
  margin-bottom: 2rem;
}

form {
  display: grid;
  gap: 1rem;
}

.form-group {
  display: grid;
  gap: 0.5rem;
}

label {
  color: #111827;
  font-weight: bold;
}

input[type='password'] {
  padding: 0.75rem;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 1rem;
  color: #111827;
}

button {
  padding: 0.75rem;
  background-color: #2196f3;
  color: white;
  border: none;
  border-radius: 4px;
  font-weight: bold;
  cursor: pointer;
}

button:hover:not(:disabled) {
  background-color: #1976d2;
}

button:disabled {
  background-color: #ccc;
}

.error {
  background-color: #ffebee;
  color: #c62828;
  padding: 0.75rem;
  border-radius: 4px;
}
</style>

